import { render, staticRenderFns } from "./AssistantPage.vue?vue&type=template&id=a9d8cd8c&scoped=true"
import script from "./AssistantPage.vue?vue&type=script&lang=js"
export * from "./AssistantPage.vue?vue&type=script&lang=js"
import style0 from "./AssistantPage.vue?vue&type=style&index=0&id=a9d8cd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d8cd8c",
  null
  
)

export default component.exports